// WickScope brand mark: five candlestick "spark bars" (green/burnt-orange)
// on a dark rounded tile. Mirrors the mark in the design canvas. Colors are
// baked rather than tokenized so the mark reads the same on any theme/surface.

const POS = "#2F8A5D";
const ACCENT = "#C8632A";

interface Candle {
  x: number;
  bodyTop: number;
  bodyHeight: number;
  wickTop: number;
  wickHeight: number;
  color: string;
}

// Laid out in a 32x32 viewBox: five candles of varying height, the middle
// one tallest and accented, matching the design's spark-bar rhythm.
const CANDLES: readonly Candle[] = [
  { x: 6.6, bodyTop: 13, bodyHeight: 8, wickTop: 10, wickHeight: 14, color: POS },
  { x: 10.8, bodyTop: 10, bodyHeight: 12, wickTop: 7, wickHeight: 18, color: POS },
  { x: 15, bodyTop: 7, bodyHeight: 16, wickTop: 4, wickHeight: 22, color: ACCENT },
  { x: 19.2, bodyTop: 11, bodyHeight: 10, wickTop: 8, wickHeight: 16, color: POS },
  { x: 23.4, bodyTop: 12.5, bodyHeight: 7, wickTop: 9.5, wickHeight: 13, color: ACCENT },
];

const BODY_WIDTH = 2.6;
const WICK_WIDTH = 0.9;

export function BrandMark({ size = 30 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      role="img"
      aria-label="WickScope"
      className="shrink-0"
    >
      <rect width="32" height="32" rx="8" fill="#15110D" />
      <rect
        x="0.5"
        y="0.5"
        width="31"
        height="31"
        rx="7.5"
        fill="none"
        stroke="#2A241D"
      />
      {CANDLES.map((c) => (
        <g key={c.x}>
          <rect
            x={c.x + (BODY_WIDTH - WICK_WIDTH) / 2}
            y={c.wickTop}
            width={WICK_WIDTH}
            height={c.wickHeight}
            rx={WICK_WIDTH / 2}
            fill={c.color}
          />
          <rect
            x={c.x}
            y={c.bodyTop}
            width={BODY_WIDTH}
            height={c.bodyHeight}
            rx={BODY_WIDTH / 2}
            fill={c.color}
          />
        </g>
      ))}
    </svg>
  );
}
